/**
 * Mira API Management Service
 * Our API uses a REST based design, leverages the JSON data format, and relies upon HTTPS for transport. We respond with meaningful HTTP response codes and if an error occurs, we include error details in the response body. API Documentation is at sweyainfotech.com/contact
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface MiraManagementApiDomainFloorsDtosFloorDto { 
    id?: string;
    indoorPlanImageUrl?: string | null;
    height?: number;
    width?: number;
    no?: number;
    canvasResolutionX?: number;
    canvasResolutionY?: number;
    indoorPlanImageResolutionX?: number;
    indoorPlanImageResolutionY?: number;
    p?: number;
}

